function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { X } from '@finect/tabular-icons/x';
import { ChevronLeft } from '@finect/tabular-icons/chevronLeft';
import { getProductTypeById } from '@finect/front-resources/Products';
import { MenuBackground, Menu, Close, MenuContent, Inner, NavBack } from './partials';
import { NavMenuSection } from './NavMenuSection';
export class NavMenu extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      hide: false,
      firstLevel: null,
      secondLevel: null
    });
    _defineProperty(this, "hideMenu", () => {
      this.setState({
        hide: true
      }, () => setTimeout(() => {
        this.props.onClose();
        this.setState({
          hide: false,
          firstLevel: null,
          secondLevel: null
        });
      }, 300));
    });
    _defineProperty(this, "handleFirstLevelClick", (event, item) => {
      if (item.hasOwnProperty('children')) {
        event.preventDefault();
        return this.setState({
          firstLevel: item.id
        });
      }
      this.handleFinalAction();
    });
    _defineProperty(this, "handleSecondLevelClick", (event, item) => this.setState({
      secondLevel: item.id
    }));
    _defineProperty(this, "handleBack", () => {
      if (this.state.secondLevel) return this.setState({
        secondLevel: null
      });
      if (this.state.firstLevel) return this.setState({
        firstLevel: null,
        secondLevel: null
      });
    });
    _defineProperty(this, "handleFinalAction", () => this.hideMenu());
  }
  render() {
    const {
      show,
      menuRef,
      finectApp,
      blocks = [],
      productFamilies,
      links,
      banks = [],
      storefronts = []
    } = this.props;
    const {
      hide
    } = this.state;
    const sections = blocks.map(_ref => {
      let {
        entitiesType,
        entitiesFilter,
        title,
        link = null
      } = _ref;
      if (entitiesType === 'productFamily') {
        const items = productFamilies.map(family => _objectSpread(_objectSpread({}, {
          productType: getProductTypeById(family.type)
        }), family)).filter(_ref2 => {
          let {
            productType
          } = _ref2;
          return Boolean(productType);
        });
        const indexFundsItem = {
          productType: {
            slug: 'fondos-indexados',
            plural: 'Fondos indexados',
            tag: 'fondos-indexados',
            views: []
          },
          id: 1,
          alias: 'fondos-indexados',
          familly: 'index-funds',
          type: 'index-fund'
        };
        items.length > 1 ? items.splice(1, 0, indexFundsItem) : items.push(indexFundsItem);
        return {
          title,
          link,
          entitiesType,
          items
        };
      }
      if (entitiesType === 'link') {
        return {
          title,
          link,
          entitiesType,
          items: links
        };
      }
      if (entitiesType === 'storefront') {
        return {
          title,
          link,
          entitiesType,
          items: storefronts.filter(_ref3 => {
            let {
              types
            } = _ref3;
            return types.find(_ref4 => {
              let {
                type
              } = _ref4;
              return type === entitiesFilter;
            });
          })
        };
      }
      if (entitiesType === 'banks') {
        return {
          title,
          link,
          entitiesType,
          items: banks
        };
      }
      return null;
    });
    return React.createElement(Inner, {
      showMenu: show
    }, React.createElement(MenuBackground, {
      animate: hide
    }), React.createElement(Menu, {
      animate: hide,
      ref: menuRef
    }, React.createElement(Close, {
      onClick: this.hideMenu
    }, React.createElement(X, {
      strokeWidth: "2.2",
      size: "24"
    })), React.createElement(MenuContent, null, this.state.firstLevel || this.state.secondLevel ? React.createElement(NavBack, {
      onClick: this.handleBack
    }, React.createElement(ChevronLeft, null), React.createElement("span", null, "Volver")) : null, sections.filter(item => item).map((section, index) => React.createElement(NavMenuSection, {
      key: index,
      onLinkClick: () => {
        this.props.onClose();
      },
      finectApp: finectApp,
      title: section.title,
      link: section.link,
      entities: {
        items: section.items,
        type: section.entitiesType
      }
    })))));
  }
}